import { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthContext } from '../../contexts/AuthContext/AuthContext'
import { resetarChat } from '../../components/ChatSuporte/movidesk'
import { apiService } from '../../services/_config_/apiservice'
import { Title } from '../Predictions/Predictions.style'

export function Logout() {
  const [load, setLoad] = useState(true)

  const { setAuthentified } = useContext(AuthContext)

  useEffect(() => {
    apiService.defaults.headers.common.Authorization = ''
    apiService.defaults.headers.common['X-TENANT-ID'] = ''
    localStorage.removeItem('token')
    localStorage.removeItem('X-TENANT-ID')
    localStorage.removeItem('adm')
    localStorage.removeItem('usuario')
    localStorage.removeItem('filtroVendedor')
    localStorage.removeItem('filtroStatus')
    localStorage.removeItem('filtroCliente')
    localStorage.removeItem('filtroEmpresa')
    localStorage.removeItem('filtroProduto')
    localStorage.removeItem('clienteFiltrado')
    localStorage.removeItem('vendedorFiltrado')
    localStorage.removeItem('empresaFiltrada')
    localStorage.removeItem('produtoFiltrado')
    // Segmento/Categoria guardam TEXTO (nome do segmento), nao id: sobrando de uma sessao para
    // outra, o proximo usuario abriria a Predicao filtrada por segmentos que podem nem existir na
    // organizacao dele — listagem vazia, com os chips exibindo nomes de outro tenant.
    localStorage.removeItem('filtroSegmentoPredicao')
    localStorage.removeItem('segmentoFiltradoPredicao')
    localStorage.removeItem('filtroCategoriaPredicao')
    localStorage.removeItem('categoriaFiltradaPredicao')
    // Secoes recolhidas do menu: os ids valem por PERFIL (o admin tem
    // "administracao", o vendedor nao), entao a preferencia de um usuario nao
    // deve reger a barra do proximo nesta mesma maquina.
    localStorage.removeItem('menuSecoesAbertas')
    // O chat de suporte vive fora do React (script do fornecedor, montado no body): oculta o
    // widget e esquece a identidade, para o próximo usuário não herdar a conversa do anterior.
    resetarChat()
    setAuthentified(false)
    setLoad(false)
  }, [])
  if (load) {
    return <Title>Desconectando...</Title>
  }
  return <Navigate to="/" />
}
